// Toevoegen vanuit het upsell-blok in de lade (snippets/ai-cart-upsell.liquid).
// Luistert op document, want de lade vervangt haar eigen inhoud bij elke wijziging.
document.addEventListener('click', async (e) => {
  const knop = e.target.closest('[data-ai-upsell-add]');
  if (!knop) return;
  e.preventDefault();
  const lade = document.querySelector('cart-drawer');
  const oud = knop.textContent;
  knop.setAttribute('disabled', '');
  knop.textContent = 'Adding…';
  try {
    const r = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(knop.dataset.aiUpsellAdd), quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      }),
    });
    const json = await r.json();
    if (json.status) throw new Error(json.description || json.message);
    if (lade && json.sections) lade.renderContents(json);
    else window.location.reload();
  } catch (fout) {
    knop.removeAttribute('disabled');
    knop.textContent = oud;
    console.error('upsell toevoegen mislukt:', fout);
  }
});
